// extracted by mini-css-extract-plugin
export default {"root":"expander__root","show":"expander__show","collapse":"expander__collapse"};